import { render } from "./ShowRoom.vue?vue&type=template&id=63184b9a&scoped=true"
import script from "./ShowRoom.vue?vue&type=script&lang=js"
export * from "./ShowRoom.vue?vue&type=script&lang=js"

import "./ShowRoom.vue?vue&type=style&index=0&id=63184b9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63184b9a"]])

export default __exports__